import React, { useState, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Logo from "../images/logoss.png";
import "../styles/verifyotp.css";

const VerifyPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { resetPasswordWithOtp } = useContext(AuthContext);

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email") || "";

  const [otpArray, setOtpArray] = useState(["", "", "", "", "", ""]);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const inputRefs = useRef([]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/, "");
    if (value.length > 1) return;

    const newOtp = [...otpArray];
    newOtp[index] = value;
    setOtpArray(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }

    if (!value && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

   const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();

      if (otpArray[index]) {
        const newOtp = [...otpArray];
        newOtp[index] = "";
        setOtpArray(newOtp);
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
        const newOtp = [...otpArray];
        newOtp[index - 1] = "";
        setOtpArray(newOtp);
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const isFormValid =
    otpArray.every((digit) => digit !== "") &&
    newPassword.trim() !== "" &&
    confirmPassword.trim() !== "" &&
    newPassword === confirmPassword;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setLoading(true);

    const otp = otpArray.join("");

    const res = await resetPasswordWithOtp(email, otp, newPassword);

    if (res.error) {
      setError(res.error);
    } else {
      setMessage("Password has been reset successfully!");
      setTimeout(() => navigate("/login"), 1500);
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      {/* Left side background like Login page */}
      <div className="login-left">
        <div className="login-left-content">
          <h2>SubnetExpress</h2>
          <p>Secure your account by resetting your password safely and quickly.</p>
        </div>
      </div>

      {/* Right side form box */}
      <div className="login-right">
        <div className="">
          <div className="login-box">
            <img src={Logo} alt="Logo" className="login-logo" />
            <h2 className="login-title">Reset Your Password</h2>
            <p className="login-subtext">
              Enter the 6-digit OTP sent to your email and choose a new password.
            </p>

            <form onSubmit={handleSubmit} className="verify-form">
              <div className="verify-otp-container">
                {otpArray.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    required
                  />
                ))}
              </div>

              <div className="verify-input-group">
                <input
                  type="password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className={`verify-input ${newPassword && newPassword.length < 6 ? "input-error" : ""}`}
                  required
                />
                {newPassword && newPassword.length < 6 && (
                  <p className="error-input">Password must be at least 6 characters</p>
                )}
              </div>

              <div className="verify-input-group">
                <input
                  type="password"
                  placeholder="Confirm New Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={`verify-input ${confirmPassword && confirmPassword !== newPassword ? "input-error" : ""}`}
                  required
                />
                {confirmPassword && confirmPassword !== newPassword && (
                  <p className="error-input">Passwords do not match</p>
                )}
              </div>

            {error && <p className="error-text">{error}</p>}
            {message && <p className="bulk-success">{message}</p>}

              <button
                type="submit"
                className="verify-button"
                disabled={!isFormValid || loading}
              >
                {loading ? <div className="verify-spinner" /> : "Reset Password"}
              </button>
            </form>

           
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPassword;
